"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProteusError_1 = require("../errors/ProteusError");
var ArrayUtil = {
    assert_is_not_zeros: function (array) {
        var only_zeroes = true;
        for (var val in array) {
            if (parseInt(val) > 0) {
                only_zeroes = false;
                break;
            }
        }
        if (only_zeroes === true) {
            throw new ProteusError_1.default('Array consists only of zeroes.', ProteusError_1.default.CODE.CASE_100);
        }
    },
    concatenate_array_buffers: function (buffers) {
        return buffers.reduce(function (accumulator, bytes) {
            var buffer = new Uint8Array(accumulator.byteLength + bytes.byteLength);
            buffer.set(accumulator, 0);
            buffer.set(bytes, accumulator.byteLength);
            return buffer;
        });
    },
};
exports.default = ArrayUtil;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/util/ArrayUtil.js
// module id = 40
// module chunks = 0 1